import React from 'react';
import PageSEO from '../components/PageSEO';
import WebContactForm from '../components/WebContactForm';
import { SITE_INFO, BRAND_ASSETS } from '../data';

export default function JobPage() {
  return (
    <div className="bg-stone-100 min-h-screen">
      <PageSEO
        title="Vi søger folk til KTS-Entreprise | Frederiksværk"
        description="Vi søger 2 stærke hænder – eller et helt sjak – til KTS-Entreprise!"
        ogTitle="Vi søger folk | KTS-Entreprise A/S"
        ogDescription="Vi har travlt og søger 2 mand med erfaring eller et sammentømret sjak."
        ogImage={BRAND_ASSETS.truckJob}
        slug="copy-of-kts-entreprise-a-s"
      />

      {/* Header Banner */}
      <section className="bg-stone-900 text-white pt-36 sm:pt-44 md:pt-48 lg:pt-52 pb-12 sm:pb-16 border-b-4 border-[#0072c0]">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <h1 className="text-3xl sm:text-5xl font-black uppercase tracking-tight text-white font-heading">
            Vi søger folk til KTS-Entreprise
          </h1>
          <p className="text-stone-300 text-sm sm:text-base mt-2 max-w-2xl">
            Vil du være en del af vores team?
          </p>
        </div>
      </section>

      {/* Main Content */}
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12 sm:py-16">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 items-start mb-16">
          
          <div className="lg:col-span-7 space-y-6">
            <div className="border-l-4 border-[#0072c0] pl-4">
              <h2 className="text-2xl sm:text-3xl font-black uppercase text-stone-900 font-heading leading-tight">
                Vi søger 2 stærke hænder – eller et helt sjak – til KTS-Entreprise!​
              </h2>
            </div>

            <p className="text-stone-800 text-base sm:text-lg font-medium leading-relaxed">
              Er du typen, der kan styre en skovl, en pladevibrator eller en minigraver uden at spilde morgenkaffen?
            </p>

            <p className="text-stone-700 text-sm sm:text-base leading-relaxed">
              Så er det måske dig (og din makker), vi mangler hos KTS-Entreprise!
            </p>

            <p className="text-stone-700 text-sm sm:text-base leading-relaxed">
              Vi har travlt – rigtig travlt – og derfor leder vi efter 2 mand med erfaring (eller et sammentømret sjak), der ikke er bange for at tage fat og som har kørekort i orden.​
            </p>

            {/* Hvem er vi? */}
            <div className="bg-white p-6 border border-stone-200 rounded-xs space-y-2">
              <h3 className="font-heading font-black text-lg uppercase text-stone-900">
                Hvem er vi?
              </h3>
              <p className="text-stone-700 text-xs sm:text-sm leading-relaxed">
                Vi er KTS-Entreprise – en entreprenørvirksomhed med base i Nordsjælland. Vi arbejder med alt fra:
              </p>
              <ul className="space-y-1 text-xs sm:text-sm text-stone-800 font-medium pl-4 list-disc">
                <li>Belægning af fliser, sten og granit</li>
                <li>Kloak- og drænarbejde</li>
                <li>Fundamenter og jordarbejde</li>
                <li>TV-inspektion og serviceopgaver</li>
              </ul>
              <p className="text-stone-700 text-xs sm:text-sm leading-relaxed pt-2">
                Vi går op i godt håndværk og en ordentlig tone. Hos os er der højt til loftet og plads til grin.
              </p>
            </div>

            {/* Vi forventer */}
            <div className="space-y-2 bg-white p-6 border border-stone-200 rounded-xs">
              <h3 className="font-heading font-black text-lg uppercase text-stone-900 mb-3">
                Vi forventer, at du:
              </h3>
              <ul className="space-y-2 text-xs sm:text-sm text-stone-800">
                <li className="flex items-start gap-2.5">
                  <i className="fa-solid fa-check text-[#0072c0] mt-1 shrink-0"></i>
                  <span>Har erfaring inden for anlæg, belægning eller kloak</span>
                </li>
                <li className="flex items-start gap-2.5">
                  <i className="fa-solid fa-check text-[#0072c0] mt-1 shrink-0"></i>
                  <span>Kan arbejde selvstændigt og tage ansvar for opgaverne</span>
                </li>
                <li className="flex items-start gap-2.5">
                  <i className="fa-solid fa-check text-[#0072c0] mt-1 shrink-0"></i>
                  <span>Har kørekort (B er et krav, gerne BE)</span>
                </li>
                <li className="flex items-start gap-2.5">
                  <i className="fa-solid fa-check text-[#0072c0] mt-1 shrink-0"></i>
                  <span>Møder til tiden og er en god kollega</span>
                </li>
              </ul>
            </div>
          </div>

          <div className="lg:col-span-5 space-y-6">
            <div className="border border-stone-200 bg-white p-2 rounded-xs">
              <img
                src={BRAND_ASSETS.truckJob}
                alt="KTS-Entreprise lastbil"
                className="w-full h-auto object-cover rounded-xs"
              />
            </div>

            <div className="bg-stone-900 text-white p-6 rounded-xs border border-stone-800 space-y-2">
              <h3 className="font-heading font-bold uppercase text-stone-100 text-sm">
                Interesseret i at høre mere?
              </h3>
              <p className="text-xs text-stone-300">
                Ring direkte til os eller send en kort introduktion.
              </p>
              <a
                href={`tel:${SITE_INFO.mainPhone.replace(/\s+/g, '')}`}
                className="inline-flex items-center gap-2 text-sm font-mono font-bold text-[#0072c0] hover:underline pt-2 block"
              >
                <i className="fa-solid fa-phone"></i>
                <span>Tlf. {SITE_INFO.mainPhone}</span>
              </a>
            </div>
          </div>

        </div>

        <WebContactForm
          title="Send en uopfordret ansøgning"
          subtitle="Fortæl os lidt om dig selv og din erfaring."
          submitText="Send ansøgning"
          showAddress={false}
          showFileUpload={true}
          fileLabel="Vedhæft dit CV eller referencer (valgfrit)"
        />
      </div>
    </div>
  );
}
